import { render, staticRenderFns } from "./MailerApprovalForm.vue?vue&type=template&id=57b8793a&scoped=true&"
import script from "./MailerApprovalForm.vue?vue&type=script&lang=js&"
export * from "./MailerApprovalForm.vue?vue&type=script&lang=js&"
import style0 from "./MailerApprovalForm.vue?vue&type=style&index=0&id=57b8793a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8793a",
  null
  
)

export default component.exports